import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import oidc from "Services/oidc";
Vue.use(VueAxios, axios);

window.axios = axios;

/* Allows Us To Authorized Api Request If Authenticated Using Web Middleware */
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

window.axios.interceptors.request.use(
    async config => {
        config.headers = config.headers || {};

        /* Set The Token if Present So We Can Authorize Request */
        let token = document.head.querySelector('meta[name="csrf-token"]');
        if (token) {
            config.headers["X-CSRF-TOKEN"] = token.content;
            config.headers["X-Requested-With"] = "XMLHttpRequest";
        } else {
            console.error(
                "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
            );
        }
        config.headers["Workstation-ID"] = window.vm.$store.getters['workstation/getWorkstationId']
        const accessToken = await oidc.getAccessToken();
        if (accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config
    },
    error => {
        console.error(error)
    }
)

window.axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const response = error.response || {};
    switch (response.status) {
      case 401:
        oidc.removeUser();
        vm.$store.commit("auth/logout");
        window.location.assign(route("login"));
        break;
      case 404:
        vm.$router.replace("/404");
        break;
      case 402:
        vm.$router.push("subscribe");
        break;
    }
    return Promise.reject(error);
  }
);
